import React from "react";

function ProfileEditing({
  profileName,
  iconsName,
  editButton,
  setEditProfileData,
  name,
  index,
  type
}) {
  const handleInputChange = (e) => {
    const { value} = e.target;
    setEditProfileData((prevData) =>
      prevData.map((item, idx) =>
        idx === index ? { ...item, profileName: value } : item
      )
    );
    // setEditProfileData((prevData) => ({
    //   ...prevData, organizationName: e.target.value
    // }));
  };

  return (
    <div className={`mb-1 valign-wrapper gap-1 `}>
      <span
        className="material-icons cercle-purple-text"
        style={{ fontSize: "25px" }}
      >
        {iconsName}
      </span>
      {editButton ? (
        <div className="flex column full-width mr-2">
        <p className="title">{name} <span className="red-text">*</span></p>
        <input
          className="input-tag-style full-width"
          type="text"
          value={profileName}
          onChange={handleInputChange}
          disabled={type === "email" || type === "phone"}
        />
        </div>
        
      ) : (
       
        <p className="title">{name}: {profileName}</p>
      
      )}
    </div>
  );
}

export default ProfileEditing;
